import { Injectable } from '@angular/core';
import { Observable, map, of, EMPTY, BehaviorSubject } from 'rxjs';
import { GlobalConstants } from 'src/app/shared/constants/global-constants';
import { CommonHttpService } from './common-http.service';
import { CommonService } from './common.service';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class ActionPlanService {

  constructor(private _commonHttpService: CommonHttpService, private storageService: StorageService,
    private commonService: CommonService) { }

  private actionPlanCountChange$ = new BehaviorSubject<boolean>(false);
  isActionPlanCountChange$ = this.actionPlanCountChange$.asObservable();

  setActionPlanCountChange(isCountChange: boolean) {
    this.actionPlanCountChange$.next(isCountChange);
  }

  public getPendingActionPlans(data: any): Observable<any> {

    const url = this.commonService.getFullUrl(GlobalConstants.FETCH_ACTION_PLANS);
    let encryptedRqstBody = {
      rqstBody: this.commonService.encryptUsingAES256(data)
    }
    return this._commonHttpService.post(url, encryptedRqstBody, {}, {})
      .pipe(map((response, error) => {
        if (response) {
          //console.log('pending plans response: ', response);
          return response.body;
        } else {
          return error;
        }
      }));
  }

  public getRejectedActionPlans(data: any): Observable<any> {
    const url = this.commonService.getFullUrl(GlobalConstants.FETCH_ACTION_PLANS);
    let encryptedRqstBody = {
      rqstBody: this.commonService.encryptUsingAES256(data)
    }
    return this._commonHttpService.post(url, encryptedRqstBody, {}, {})
      .pipe(map((response, error) => {
        if (response) {
          //console.log('rejected plans response: ', response);
          return response.body;
        } else {
          return error;
        }
      }));
  }

  public getHistoricalActionPlans(data: any): Observable<any> {
    const url = this.commonService.getFullUrl(GlobalConstants.FETCH_ACTION_PLANS);
    let encryptedRqstBody = {
      rqstBody: this.commonService.encryptUsingAES256(data)
    }
    return this._commonHttpService.post(url, encryptedRqstBody, {}, {})
      .pipe(map((response, error) => {
        if (response) {
          //console.log('historical plans response: ', response);
          return response.body;
        } else {
          return error;
        }
      }));
  }

  public getAllActionPlans(data: any): Observable<any> {
    const url = this.commonService.getFullUrl(GlobalConstants.FETCH_ACTION_PLANS);
    let encryptedRqstBody = {
      rqstBody: this.commonService.encryptUsingAES256(data)
    }
    return this._commonHttpService.post(url, encryptedRqstBody, {}, {})
      .pipe(map((response, error) => {
        if (response) {
          //console.log('historical plans response: ', response);
          return response.body;
        } else {
          return error;
        }
      }));
  }

  public getActionItems(data: any): Observable<any> {

    const url = this.commonService.getFullUrl(GlobalConstants.FETCH_ACTION_ITEMS);
    let encryptedRqstBody = {
      rqstBody: this.commonService.encryptUsingAES256(data)
    }
    return this._commonHttpService.post(url, encryptedRqstBody, {}, {})
      .pipe(map((response, error) => {
        if (response) {
          //console.log('action items response: ', response);
          return response.body;
        } else {
          return error;
        }
      }));
  }

  public saveActionItem(data: any): Observable<any> {
    const url = this.commonService.getFullUrl(GlobalConstants.SAVE_ACTION_ITEM);
    let encryptedRqstBody = {
      rqstBody: this.commonService.encryptUsingAES256(data)
    }
    return this._commonHttpService.post(url, encryptedRqstBody, {}, {})
      .pipe(map((response, error) => {
        if (response) {
          //console.log('save action item response: ', response);
          return response.body;
        } else {
          return error;
        }
      }));
  }

}
